'use client';

import {Scroller} from '@shared/Scroller/Scroller';
import cn from '@sindresorhus/class-names';

import ScreenshotsModal from '@web-catalog/components/ScreenshotsModal';

import {AppsSelectionContent, Orientation} from '@web-catalog/types';

import {useModalState} from '@web-catalog/hooks';

import styles from './ScreenshotsComponent.module.scss';

/* eslint-disable @next/next/no-img-element */

export const ScreenshotsComponent = ({
  content,
  featuringName,
}: {
  content: AppsSelectionContent & {type: 'SCREENSHOTS'};
  featuringName?: string;
}) => {
  const modalSliderState = useModalState<number>();

  return (
    <>
      <Scroller classes={{root: styles.screenshots}} variant="grid">
        {content.screenshots.map((screenshot, index) => (
          <img
            key={index}
            className={cn(styles.screenshot, {
              [styles.portrait]:
                screenshot.orientation === Orientation.PORTRAIT,
              [styles.landscape]:
                screenshot.orientation === Orientation.LANDSCAPE,
            })}
            loading="lazy"
            data-testid={'features_slider_slide'}
            onClick={() => modalSliderState.open(index)}
            src={screenshot.fileUrl}
            alt={`Скриншот ${index + 1}/${content.screenshots.length}`}
          />
        ))}
      </Scroller>
      <ScreenshotsModal
        appName={featuringName || ''}
        fileUrls={content.screenshots}
        initialSlide={modalSliderState.data || 0}
        modalType="FeaturingScreenshots"
        isOpen={modalSliderState.isOpen}
        onClose={modalSliderState.close}
      />
    </>
  );
};
